import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetERP_SendGoodsByPage,
    ERP_AuditSendGoods,
    GetSendGoodsAuditStatistics
} from '@api/sendGoodsApi';
import {
    GetOrderFinanceAuditByPage,
    ERP_AuditOrder,
    GetERP_OrderById
} from '@api/orderApi';
import NProgress from 'nprogress';
import {
    MAP_LIST
} from '$http';
import $http from '$http';

import optCooperationAgreementDetails from '@pages/Order/components/optCooperationAgreementDetails/index.vue';

export default {
    components: {
        optCooperationAgreementDetails
    },
    data: function () {
        return {
            auditBtnShow: true,
            Session: util.getSessin(),
            queryType: [{
                "TypeName": "-请选择-",
                "TypeValue": "-1"
            }, {
                "TypeName": "待审核",
                "TypeValue": "1"
            }, {
                "TypeName": "审核通过",
                "TypeValue": "2"
            }],
            loading2: false,
            lists: [{
                "Id": "346567788"
            }],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [], //列表选中列
            pageSizes: [10, 20, 50],
            policyTypeName: "",
            query: this.getQuery()
        }
    },
    methods: {
        getQuery() {
            return cloneDeep({
                c_name: "",
                customer: "",
                schoolName: "",
                PrincipalName: "",
                phone: "",
                auditstatus: ""
            });
        },
        //新增销售下单
        addOrder() {

        },
        reLoadData() {
            this.pageIndex = 1;
            this.List();
        },
        //初始化加载页面
        List: function () {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            var params = this.getParams();

            //GET /api/School/GetSchoolCoopAgreeByPage
            $http.get("api/School/GetSchoolCoopAgreeByPage", params).then(res => {
                util.doResult(this, res, () => {});
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                this.outTips(StateCode, StateMsg, Data, Cnt);
            });

        },
        //通用输入参数
        getParams() {
            var para = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };

            for (let item in this.query) {
                let value = this.query[item];
                if (value !== '') {
                    // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
                    if (typeof value == 'string') {
                        value = util.trimAllSpace(value);
                    }
                    this.query[item] = value
                    para[item] = value;
                    if (item == "auditStartDate" || item == "auditEndDate") {
                        para[item] = util.time2str(value);
                    }
                }
            }

            return para;
        },
        //通用提示信息
        outTips: function (StateCode, StateMsg, Data, Cnt) {
            if (StateCode !== 0 && StateCode !== 99) {
                this.$notify({
                    title: '错误',
                    message: StateMsg,
                    type: 'error'
                });
            } else {
                this.totalSize = Cnt;
                this.loading2 = false; //拼命加载中隐藏
                this.lists = Data;
            }
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //查询单条
        handleView: function (item) {
            this.$refs.refoptCooperationAgreementDetails.show({
                Id: item.Id,
                isReadonly: true
            });
        },
        //查询
        onQuerySubmit: function () {
            this.pageIndex = 1;
            this.List();
        },
        //查询功能
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.List();
        },
        //编辑功能
        onQueryClean: function () {
            this.query = this.getQuery();
            this.List();
        },
        //通过
        adoptHandle(item) {

            this.$confirm('是否确认审核通过?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    Id: item.Id,
                    auditStatus: 2
                };

                //GET /api/School/AuditSchoolCoopAgree
                $http.get("api/School/AuditSchoolCoopAgree", params).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: "成功",
                            message: "审核通过",
                            type: 'success'
                        });
                        this.List();
                    });
                });

            }).catch(() => {});

        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.List();
        },
        showOrHideAuditBtn() {
            // if (this.$route.path == '/Order/financialListReadyOnly') {
            //     this.auditBtnShow = false;
            // } else {
            //     this.auditBtnShow = true;
            // }
        }
    },
    watch: {
        '$route' (to, from) {
            //this.showOrHideAuditBtn();
        }
    },
    created: function () {
        this.List();
        let _session = util.getSessin();
        let para = {
            Sid: _session[0],
            Session: _session[1],
        };
        this.showOrHideAuditBtn();
    }

}


// WEBPACK FOOTER //
// ./src/pages/Order/reviewOfCooperationAgreement/vm.js